import React, { useEffect, useMemo, useRef, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import ButtonComponent from '../../../components/common/button/Button';
import DataTable from '../../../components/common/datatable/DataTable';

const DataDetails = (props) => {
    const [isGridReady, setIsGridReady] = useState(false);
  const [disableFilterBtn, setDisableFilterBtn] = useState(true);
  const [filteredTotalColumn, setFilteredTotalColumn] = useState(0);
  const [selectedColumn, setSelectedColumn] = useState('');

  const headerItems = useMemo(() => {
    return [
      {
        headerName: "AL Identifier",
        field: "alIdentifier",
        sortable: true,
        resizable: false,
        unSortIcon: true,
        pinned: true,
      },
      {
        headerName: "Menu",
        field: "title",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Category",
        field: "category",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Function",
        field: "function",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Initiator",
        field: "ticketCreatedBy",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Ticket Number",
        field: "ticketNumber",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Description",
        field: "userComments",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Created Date",
        field: "ticketModificationTimeStamp",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
      {
        headerName: "Urgency",
        field: "urgency",
        sortable: true,
        resizable: false,
        unSortIcon: true,
      },
    ];
  }, []);

    const gridApiRef = useRef(null); // Reference to the grid API

    const onColumnChange = e => {
      const col = e.target.value;
      setSelectedColumn(col);
      if (col && gridApiRef.current) {
        gridApiRef.current.ensureColumnVisible(col);
      }
    };
            
    const onGridReady = (params) => {
        gridApiRef.current = params.api; // Store the grid API instance
        setIsGridReady(true);
    };

    const onFilterChanged = (params) => {
      if (gridApiRef.current) {
        const filterModel = gridApiRef.current.getFilterModel();
        setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
        setFilteredTotalColumn(Object.keys(filterModel).length);

        // Get the filtered and total row counts
        // const filteredRowCount = params.api.getDisplayedRowCount();
        localStorage.setItem("contractReportFilterModel", JSON.stringify(filterModel));
        // setFilteredTotalItems(filteredRowCount);
      }
    };

    useEffect(() => {
        if (isGridReady && gridApiRef?.current) {
        const savedFilterModel = localStorage.getItem("contractReportFilterModel");
        if (savedFilterModel) {
            gridApiRef.current.setFilterModel(JSON.parse(savedFilterModel));
            setDisableFilterBtn(true); 
        }
        }
    }, [isGridReady]);

    const clearAllFilters = () => {
      if (gridApiRef.current) {
        gridApiRef.current.setFilterModel(null); // Clear all filters
        localStorage.removeItem("contractReportFilterModel");
        setDisableFilterBtn(true); 
      }
    };

    const gridOptions = {
      getRowId: (params) => {
        return `${params?.data?.runOutputSeqId}`;
      },
      overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
      overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
      defaultColDef: {
        sortable: true,
        filter: 'agMultiColumnFilter',
        autoHeight: true,
        cellStyle: {
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: 1.5,
          display: "flex",
          alignItems: "center",
        },
        valueGetter: (params) => {
            if (!params.data) return "";

            const field = params.colDef.field;
            const value = params.data[field];

            return value === null || value === undefined || value === "" ? "" : value;
        },
      },
      onFilterChanged,
    };
  return (
    <>
        <div style={{display: 'flex', marginBottom: '20px', justifyContent: 'space-between', alignItems: 'center'}}>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <InputLabel>Jump to Column</InputLabel>
            <Select
              id="col-select"
              value={selectedColumn}
              label="Jump to Column"
              onChange={onColumnChange}
            >
              <MenuItem value="">Select Column</MenuItem>
              {headerItems?.map(col => (
                <MenuItem key={col?.field} value={col?.field}>
                  {col?.headerName || col?.field}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
            <ButtonComponent
                maxWidth="150px"
                label="Clear All Filters"
                bgColor="black"
                color="white"
                disabled={disableFilterBtn}
                onClick={clearAllFilters}
            />
        </div>
        <DataTable
            columns={headerItems}
            rows={props?.row || []}
            enableCheckbox={false}
            height={450}
            paginationProp={props?.pagination}
            paginationPageSize={props?.paginationPageSize}
            paginationPageSizeSelector={props?.paginationPageSizeSelector}
            suppressDragLeaveHidesColumns={true}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            filteredTotalColumn={filteredTotalColumn}
        />
    </>
  )
}

export default DataDetails